const A = {
  bigMachine: "https://customer-assets-rejwkqb3.emergentagent.net/job_precision-clamping/artifacts/dy28h9rl_image.png",
  magChuck: "https://customer-assets-rejwkqb3.emergentagent.net/job_precision-clamping/artifacts/uth296ha_image.png",
  erowaChuck: "https://customer-assets-rejwkqb3.emergentagent.net/job_precision-clamping/artifacts/boq6lhr2_image.png",
  erowaPallet: "https://customer-assets-rejwkqb3.emergentagent.net/job_precision-clamping/artifacts/1ip24ahb_image.png",
  electrodeArray: "https://customer-assets-rejwkqb3.emergentagent.net/job_precision-clamping/artifacts/zof5nez6_image.png",
  inspection: "https://customer-assets-rejwkqb3.emergentagent.net/job_precision-clamping/artifacts/nud7q8di_image.png",
};

export const IMAGES = {
  hero: A.bigMachine,
  heroCollage: [
    { src: A.erowaChuck, alt: "EROWA precision clamping under grinding wheel" },
    { src: A.magChuck, alt: "Electro-permanent magnetic chuck" },
    { src: A.inspection, alt: "Modular fixturing on CMM inspection setup" },
    { src: A.electrodeArray, alt: "Multi-station chucks holding EDM electrodes" },
    { src: A.erowaPallet, alt: "EROWA zero-point pallet system" },
    { src: A.bigMachine, alt: "Large workpiece on modular clamping bed" },
  ],
  about1: A.erowaPallet,
  about2: A.electrodeArray,
  brands: {
    rudra: A.magChuck,
    erowa: A.erowaChuck,
    spreitzer: A.inspection,
  },
  industries: [
    A.erowaChuck,
    A.magChuck,
    A.electrodeArray,
    A.inspection,
  ],
};

export const BRANDS_DATA = [
  {
    id: "rudra",
    name: "Rudra Magnets",
    image: IMAGES.brands.rudra,
    gallery: [A.magChuck, A.bigMachine],
    products: [
      "Electro-permanent magnetic chucks for milling & grinding",
      "Heavy-duty magnetic lifters",
      "Coolant separators & magnetic separation",
    ],
    specs: {
      Holding: "Fail-safe magnetic force",
      "Best for": "Milling · Grinding · Handling",
      Partnership: "10+ years and counting",
    },
  },
  {
    id: "erowa",
    name: "EROWA",
    image: IMAGES.brands.erowa,
    gallery: [A.erowaChuck, A.erowaPallet, A.electrodeArray],
    products: [
      "Flexible Tooling System (FTS)",
      "Zero-point clamping (MTS)",
      "EDM & milling tooling",
      "Automation loading systems",
    ],
    specs: {
      Repeatability: "≤ 0.002 mm",
      Standard: "MTS · UPC · Wire-EDM",
      "Best for": "Die & Mould · Automation",
    },
  },
  {
    id: "spreitzer",
    name: "SPREITZER",
    image: IMAGES.brands.spreitzer,
    gallery: [A.inspection, A.bigMachine],
    products: [
      "Mechanical & hydraulic vices",
      "5-axis vices",
      "Concentric (self-centring) vices",
      "ALUMESS modular clamping range",
    ],
    specs: {
      Clamping: "High-force hydraulic & mechanical",
      "Best for": "5-axis machining · Inspection",
      Range: "ALUMESS modular system",
    },
  },
];

export const getBrand = (id) => BRANDS_DATA.find((b) => b.id === id);
